import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useUserMe } from '@/hooks/useUserMe';

import { useOrganizationId } from './useOrganizationId';

export const useUserOrganizationId = () => {
  const user = useUserMe().data;
  const isStaff = useIsStaffUser();
  const organizationId = useOrganizationId();

  return isStaff ? organizationId : user.membership.organization?.id;
};
